import './style.css';

export interface Props {
  aspect: number;
}

export const AspectContainer: React.FC<Props> = (props) => {
  return (
    <div
      className="fixed-aspect-container"
      style={{
        paddingBottom: `${props.aspect * 100}%`,
      }}
    >
      <div className="fixed-aspect-content">{props.children}</div>
    </div>
  );
};
